import request from "@/lib/api/handler";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";
import {
  ChecklistContractStatuses,
  ChecklistSourcingStatuses,
  JobOpeningStatus,
} from "@/types";

export interface AdminJobChecklist {
  id: string;
  role?: string;
  status: JobOpeningStatus;
  loiComplete: boolean;
  jobDescriptionComplete: boolean;
  cultureComplete: boolean;
  companyProfileComplete: boolean;
  interviewStructureComplete: boolean;
  interviewingComplete: boolean;
  salaryAndScope?: string;
  sourcingStatus: ChecklistSourcingStatuses;
  shortlistStatus: ChecklistSourcingStatuses;
  masterServiceAgreementStatus: ChecklistContractStatuses;
  statementOfWorkStatus: ChecklistContractStatuses;
  ndaStatus: ChecklistContractStatuses;
  company: {
    id: string;
    name?: string;
    logoLink?: string;
  };
  createdAt: string;
}

export const useAdminJobChecklistQuery = () => {
  const { getAccessTokenSilently } = useAuth0();
  const {
    data: adminJobChecklist,
    error: adminJobChecklistError,
    isLoading: adminJobChecklistLoading,
  } = useQuery({
    queryKey: QueryKeys.adminJobChecklist,
    enabled: true,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    async queryFn() {
      const token = await getAccessTokenSilently();
      return await request<AdminJobChecklist[]>({
        method: "GET",
        path: "/api/admin/job_checklist",
        token,
      });
    },
  });

  return {
    adminJobChecklist,
    adminJobChecklistError,
    adminJobChecklistLoading,
  };
};
